module.exports = __webpack_public_path__ + "static/media/eu_flag_2.6b532361.png";